import { FunctionComponent, ReactElement, useState } from 'react';
import { Stack, Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import SiteFormSection from '../components/SiteFormSection';
import LevelTextField from '../components/LevelTextField';
import { SiteFormSectionProps } from './types';
import LevelRemoveConfirmation from '../components/LevelRemoveConfirmation';

const SectionLocationStructure: FunctionComponent<SiteFormSectionProps> = ({
	formModel,
	setFormModel,
}): ReactElement => {

	const [levelRemoveConfirm, setLevelRemoveConfirm] = useState<{
		open: boolean;
		level?: { id?: string; name: string };
	}>({
		open: false,
	});

	const onLevelRemove = (id: string) => {
		const levelIndex = formModel.structure.findIndex((level) => level?.id === id);
		setFormModel({
			...formModel,
			structure: [
				...formModel.structure.slice(0, levelIndex),
				...formModel.structure.slice(levelIndex).filter((level) => !level.id),
			],
		});
	};

	return (
		<SiteFormSection
			title="Location structure"
			description="Set up a location structure that best suits this site’s needs (E.g.
								Building/Floor/Room). You will be able to enter specific location names later."
			width={null}
		>
			{formModel.structure.map((level, key) => (
				<LevelTextField
					key={key}
					level={level.name}
					name={`level[${key + 1}]`}
					label={`Level ${key + 1}`}
					isRemovable={key !== 0}
					onChange={(event) =>
						setFormModel({
							...formModel,
							structure: formModel.structure.map((value, index) =>
								index === key ? { ...value, name: event.target.value } : value
							),
						})
					}
					onRemove={() => {
						if (level.id) {
							setLevelRemoveConfirm({ ...levelRemoveConfirm, open: true, level });
						} else {
							setFormModel({
								...formModel,
								structure: formModel?.structure.filter((_, index) => index !== key),
							});
						}
					}}
				/>
			))}

			<Stack direction="row" justifyContent="start">
				<Button
					variant="text"
					startIcon={<AddRounded />}
					onClick={() =>
						setFormModel({ ...formModel, structure: [...formModel.structure, { name: '' }] })
					}
				>
					Add more
				</Button>
			</Stack>

			<LevelRemoveConfirmation
				open={levelRemoveConfirm.open}
				onClose={() => setLevelRemoveConfirm({ ...levelRemoveConfirm, open: false })}
				level={levelRemoveConfirm.level}
				onConfirm={onLevelRemove}
			/>
		</SiteFormSection>
	);
};

export default SectionLocationStructure;
